// File: src/pages/NotFoundPage.tsx

import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const dogImages = [
    require('assets/dogs/dog2.png'),
    require('assets/dogs/dog3.png'),
    require('assets/dogs/dog4.png'),
    require('assets/dogs/dog4.png')
];

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();
    const [dogImg] = useState(
        dogImages[Math.floor(Math.random() * dogImages.length)]
    );

    return (
        <Box
            sx={{
                height: '100vh',
                bgcolor: '#f3f3f3',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2,
            }}
        >
            <Typography variant="h3" gutterBottom>
                Sorry, we couldn’t find that page.
            </Typography>

            {/* 犬の画像 */}
            <Box
                component="img"
                src={dogImg}
                alt="404 dog"
                sx={{
                    maxWidth: 320,
                    width: '80%',
                    borderRadius: 2,
                    boxShadow: 3,
                    mb: 2,
                }}
            />

            <Typography variant="body1" gutterBottom>
                It looks like nothing was found at this location. How about going back home?
            </Typography>

            <Box sx={{ mt: 2 }}>
                <Button
                    variant="contained"
                    onClick={() => navigate('/')}
                    sx={{ textTransform: 'none' }}
                >
                    Go to Home
                </Button>
            </Box>

        </Box>
    );
};

export default NotFoundPage;
